import { library } from '@fortawesome/fontawesome-svg-core';
import * as icons from './fontawesomeIcons';

library.add(icons);
